<template>
  <div class="xianxia-xingwei-detail child-detail">
    <ChildModal :title="$store.state.childModalTitle" >
      <div class="tingliushijian single-line">
        <div class="chart-content">

            <section class="section">
              <div class="left">
                 <img  src="../../assets/jingqukoubei/doujiangyan.png"/>
              </div>
            </section>
            <section class="section">

               <div class="right">
                  <div class="left">游客满意度 <span>8.5</span></div>
                 <div class="right">
                     
                 <ul>
                    <li>
                        本市排名 
                        <div>top3</div>
                    </li>
                     <li>最高项-服务
                         <div>9.0</div>
                     </li>
                     <li>最需提升-安全
                 <div>5.2</div></li>
                     <li>环比上升
                 <div>2%</div></li>
                     <li>同比下降
                 <div>1%</div></li>
                 </ul>
                 </div>

               </div>
            </section>
            <div class="clear"></div>
        </div>
      </div>

      <div class="tingliushijian single-line">
        <div class="chart-title">
          都江堰景区口碑指数各项得分
        </div>
        <div class="chart-content">
          <!--<div class="chart-title">情绪占比图</div>-->
          <div class="chart-content">
            <RainDropBar
              id="rainDropBar"
              :chartData="jingqukoubeizhishugexiangdefenData"
              v-if="jingqukoubeizhishugexiangdefenData"
            />
          </div>
        </div>
      </div>
      <div class="zhanwei"></div>
    </ChildModal>
  </div>
</template>

<script>
import ChildModal from "@/components/Common/ChildModal.vue";

import RainDropBar from "@/components/Echarts/JingquKoubei/RainDropBar.vue";


export default {
  name: "scenicjingqukoubei",
  components: {
    ChildModal,
      RainDropBar
  },
  props: {},
  data() {
    return {
        jingqukoubeizhishugexiangdefenData:null,
    };
  },
  mounted() {
    // setTimeout(() => {
    //   this.$refs.pointer2.style.transform = "rotate(90deg)";
    // }, 500);

    // 请求景区级别-景区口碑指数各项得分

    fetch("/data/JingquKoubei/ScenicJingquKoubei/JingquKoubeiZhishuGexiangDefen.json")
      .then(response => {
        return response.json();
      })
      .then(json => {
        this.jingqukoubeizhishugexiangdefenData = json.data;
      });

  },
  methods: {}
};
</script>

<style scoped lang="less">
.geyebili {
  padding: 0 1rem;
  box-sizing: border-box;
  overflow: hidden;
  margin-bottom: 0.05rem !important;
  .chart-content {
    ol {
      width: 44%;
    }
    ul {
      margin: 1rem auto 0;
      position: relative;
      .yibiao1 {
        float: left;
      }
      .yibiao3 {
        float: right;
      }
      .yibiao2 {
        position: absolute;
        left: 50%;
        top: 0;
        transform: translate(-50%, -20%) scale(1.5);
      }
      li {
        width: 2.28rem;
        height: 2.28rem;
        position: relative;
        .info {
          margin-top: 0.12rem;
          width: 100%;
          text-align: center;
          .bili {
            color: #ff553e;
          }
        }
        .bg {
          width: 2.28rem;
          height: 1.14rem;
          background: url(../../assets/youkexianxiaxingweifenxi/yibiaopan.png)
            no-repeat;
          background-size: 100% 100%;
        }
        .pointer {
          transition: all 0.4s;
          width: 2.28rem;
          height: 2.28rem;
          background: url(../../assets/youkexianxiaxingweifenxi/yibiaopan_pointer.png)
            no-repeat;
          background-size: 100% 100%;
          position: absolute;
          top: 0;
          left: 0;
          transform: rotate(0deg);
        }
      }
    }
  }
}

.child-detail {
  .tingliushijian {
    .chart-content {
      ol {
        width: 28%;
        li {
          width: 33.33%;
        }
      }
    }
  }
  .zhusuretu {
    .chart-content {
      height: 270px;
      width: 80%;
      ol {
        width: 100%;
        li {
          width: 8.33%;
        }
      }
    }
    .expand {
      height: 0.3rem;
      position: absolute;
      left: 1.1rem;
      top: 0.1rem;
      > div {
        float: left;
        height: 0.3rem;
        line-height: 0.3rem;
      }
      .local {
        width: 0.3rem;
        background: url(../../assets/youkexianxiaxingweifenxi/local.png);
        background-size: 100% 100%;
      }
      .arrow {
        width: 0.3rem;
        background: url(../../assets/header_menu/arrow.png);
        background-size: 100% 100%;
      }
      .city-list {
        position: absolute;
        left: 0;
        top: 0.3rem;
        width: 100%;
        background: #052148;
        border: 1px solid #00cdff;
        padding: 0.05rem 0;
        box-sizing: border-box;
        li:hover {
          background: #0c3964;
        }
      }
    }
  }
}

.content {
  overflow: hidden;
  width: 100%;
  height: 92.5%;
  box-sizing: border-box;
  .tab {
    width: 9.4rem;
    height: 0.24rem;
    margin: 0 auto 0.26rem;
    li {
      width: 12.5%;
      height: 100%;
      float: left;
      color: #fff;
      /*background: url(../../assets/spot_tab_bg.png);*/
      background-size: 100% 100%;
      cursor: pointer;
    }
    .current {
      /*background: url(../../assets/spot_tab_bg_.png);*/
      background-size: 100% 100%;
    }
  }
}
.header {
  /*.chart-content {*/
  /*height: 270px;*/
  /*width: 80%;*/
  ol {
    width: 100%;
    li {
      width: 8.33%;
    }
  }
  /*}*/
  .expand {
    height: 0.3rem;
    position: absolute;
    left: 1.1rem;
    top: 0.1rem;
    cursor: pointer;
    > div {
      float: left;
      height: 0.3rem;
      line-height: 0.3rem;
    }
    .local {
      width: 0.3rem;
      background: url(../../assets/youkexianxiaxingweifenxi/local.png);
      background-size: 100% 100%;
    }
    .arrow {
      width: 0.3rem;
      background: url(../../assets/header_menu/arrow.png);
      background-size: 100% 100%;
    }
    .city-list {
      position: absolute;
      left: 0;
      top: 0.3rem;
      width: 100%;
      background: #052148;
      border: 1px solid #00cdff;
      padding: 0.05rem 0;
      box-sizing: border-box;
      li:hover {
        background: #0c3964;
      }
    }
  }
}

.line {
  width: 100%;
  height: 3rem;
  margin-bottom: 0.75rem;
  > div {
    width: 50%;
    padding: 0 0.7rem;
    box-sizing: border-box;
    height: 100%;
    float: left;
  }
}
  .left{
    float:left;
    width:40%;
    /*height:1.5rem;*/
    /*box-sizing:border-box;!*怪异盒子模型*!*/
      img{width: 4rem;}
  }
  .right{
    float:right;
    width:55%;
      margin-top: 1rem;
    height:auto;
     box-sizing:border-box;/*怪异盒子模型*/
     font-size: 0.18rem;
      .left{
          
           span{
          display: block;
               color: yellow;
               font-size: 0.5rem;
      }
      }
      .right{
          margin: 0;
          text-align: left;
          ul{
              width: 2.5rem;
              li{
                  div{float: right;color: #00ccff;}
              }
          }
      }
  }
  .clear{
    clear:both
  }

</style>
